module.exports = __webpack_public_path__ + "static/media/1012048.614e8f80.png";